import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const showText = (item) => {

  gsap.to(item, {
    transform: "translateY(0)",
    opacity: 1,
    scrollTrigger: {
      trigger: item,
      start: "top bottom",
      end: "top+=200px bottom",
      // markers: true,
      scrub: true,
    },
  });
};

export default {
  showText,
};
